import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { context } from '../../../../Layout'
import useStore from '../../../../hooks/useStore'
import MenuHeader from './menuHeader'
import useUtils from '@/hooks/useUtils'
import { AnimatePresence, motion, useScroll, useTransform } from 'framer-motion'
import { get } from 'lodash'
import clsx from 'clsx'
// styles
import '../styles.header.scss'

const SectionMenu = () => {
  const { toggleIsOpened, isOpened } = useContext(context)
  const { acfOptions } = useStore()
  const { scrollYProgress } = useScroll()
  const { device } = useUtils()

  const inputRangeScroll = device === 'desktop' ? [0, 0.2] : [0, 0.05]

  // Transformamos el progreso del scroll en un color de fondo
  const backgroundColor = useTransform(
    scrollYProgress,
    inputRangeScroll, // ajusta estos valores según el punto exacto de scroll
    ['rgba(247, 244, 240, 0)', 'rgba(247, 244, 240, 1)'],
  )

  const padingHeader = useTransform(
    scrollYProgress,
    inputRangeScroll,
    device === 'desktop' ? ['44px', '14px'] : ['44px', '0px'],
  )

  const sizeLogo = useTransform(
    scrollYProgress,
    inputRangeScroll,
    device === 'desktop' ? ['125px', '90px'] : ['90px', '54px'],
  )

  const iconLogo = {
    title: get(acfOptions(), ['site_logo', 'title'], null),
    alt: get(acfOptions(), ['site_logo', 'alt'], null),
    src: get(acfOptions(), ['site_logo', 'url'], null),
  }

  return (
    <motion.div
      style={{
        width: '100%',
        position: 'fixed',
        top: 0,
        backgroundColor,
      }}
    >
      <motion.div
        style={{
          marginTop: padingHeader,
        }}
        className="sectionMenu"
      >
        <AnimatePresence>
          {!isOpened || device != 'desktop' ? (
            <motion.div
              transition={{
                duration: 0.7,
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 1 }}
            >
              <NavLink to="/" className="site-logo  relative">
                <motion.img
                  style={{
                    width: sizeLogo,
                  }}
                  transition={{
                    duration: 0.7,
                  }}
                  className="h-auto"
                  {...iconLogo}
                />
              </NavLink>
            </motion.div>
          ) : (
            <div />
          )}
        </AnimatePresence>
        <button
          onClick={() => toggleIsOpened(`${!isOpened}`)}
          className={clsx('btnMenu', isOpened && 'active')}
        >
          <span />
        </button>
      </motion.div>
      <MenuHeader iconLogo={iconLogo} />
    </motion.div>
  )
}

export default SectionMenu
